import React from 'react'
import { Card, CardContent } from '../ui/Card'

const SIGN_OUT_PATH = '/users/sign_out'

const AccountActions = () => {
  return (
    <Card className='mb-4'>
      <CardContent>
        <div className='mb-4'>
          <h2 className='mb-0'>Account Actions</h2>
        </div>

        <div className='d-flex flex-column flex-md-row'>
          <div>
            <a
              href={SIGN_OUT_PATH}
              className='btn btn-outline-danger w-100'
              data-method='delete'
              rel='nofollow'
            >
              Sign Out
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default AccountActions
